module.exports = __webpack_public_path__ + "static/data-extraction-6e3e08a6bbd02b251b0d91098b72afce.svg";